import ko from 'knockout';
import $ from 'jquery';
import _ from 'lodash';
import EndpointsCommon from '../../../app/helpers/endpoints-common';
import DataProvider from '../../../app/data-framework/data-provider';
import templateMarkup from 'raw-loader!./endpointcodecinfo-widget.html';
import DataService from '../../../modules/assurance/services/data.service';
import EndpointDevices from './endpointDevices.model';
import WebResourceSecure from '../../../modules/assurance/services/web-resource-secure.service';
import EndpointUtils from '../../../app/helpers/endpoint-utils';
import ImageService from '../../../services/image.service';
import GridFormatterCommon from '../../../app/data-formatters/grid-formatter-common';
import TranslationService from '../../../services/translation.service';
import PermissionService from '../../../services/permission.service';
import LoginService from "../../../services/login.service";

function EndpointCodecInfo(params) {
    var self = this;

    self.justUpdated = false; // this flag is used to skip one update cycle after edit-endpoints because of potential inconsistency and sequencing issue

    self.widgetSignals = params.widgetSignals;
    self.observableData = params.observableData;
    self.observableOptions = params.observableOptions;
    self.viewLevelOptions = params.viewLevelOptions;
    self.translationService = new TranslationService();

    self.gridFormatterCommon = new GridFormatterCommon();

    self.dataProvider = DataProvider.getInstance();
    self.permissionService = new PermissionService(LoginService.userObject);
    self.status = ko.observable();
    self.tags = ko.observable();
    self.tmsTag = ko.observable();
    self.model = ko.observable();
    self.serial = ko.observable();
    self.manufacturer = ko.observable();
    self.category = ko.observable();
    self.firmware = ko.observable();
    self.networkIp = ko.observable();
    self.vlan = ko.observable();

    self.cucm = ko.observable();
    self.duplex = ko.observable();
    self.primaryMgmtAddress = ko.observable();

    self.name = ko.observable();
    self.altName = ko.observable();
    self.description = ko.observable();
    self.location = ko.observable();
    self.price = ko.observable();

    self.image = ko.observable();
    self.imageWidth = ko.observable();
    self.imageHeight = ko.observable();

    self.sourceStatus = ko.observable("N/A");
    self.displayStatus = ko.observable("N/A");
    self.hardwareDetailsVisible = ko.observable(true);
    self.softwareDetailsVisible = ko.observable(true);
    self.networkDetailsVisible = ko.observable(true);
    self.userDefinedDataVisible = ko.observable(true);
    self.deviceStatusVisible = ko.observable(false);
    self.peripherals = ko.observable(new EndpointDevices([]));
    self.touchPanel = ko.observable("N/A");
    self.microphone = ko.observable("N/A");
    self.camera = ko.observable("N/A");
    self.muted = ko.observable(false);
    self.deviceInfos = ko.observable([]);

    self.endpointId = _.get(ko.unwrap(params.viewLevelOptions), 'endpointId', null);
    if (self.endpointId) {
        var options = self.observableOptions();
        options.endpointId = self.endpointId;
        self.observableOptions(options);
    }

    self.updateVLOTitle = function() {
        var vlo = self.viewLevelOptions();
        var altName = self.altName();
        var title = altName || self.name();

        if (vlo.title !== title) {
            vlo.title = _.unescape(title);
            self.viewLevelOptions(vlo);
        }
    };
    
    self.updatedEndpoint = function(endpoint) {
        // we don't want to update TMS tags
        if (endpoint.tmsTag) {
            delete endpoint.tmsTag;
        }
        endpoint.tags = EndpointsCommon.tagsTokenToRaw(endpoint.tags);

        this.dataProvider.updateEndpoint(endpoint.id, endpoint)
            .then(_.bind(function () {
                this.updateCodecDetails(endpoint);
            }, this))
            .catch(function () {
                console.error('Could not update endpoint ' + endpoint.id);
            });
        if (_.isEmpty(self.onUpdateEndpointListener)) {
            self.updateEndpointSignals.onUpdateEndpoint.remove(self.onUpdateEndpointListener);
        }
    };

    self.updateCodecDetails = function(updatedEndpoint) {
        self.justUpdated = true;

        self.altName(_.escape(updatedEndpoint.altName));
        self.description(_.escape(updatedEndpoint.description));
        self.location(_.escape(updatedEndpoint.location));
        self.price(_.escape(updatedEndpoint.price));
        self.tags(EndpointsCommon.tagsRawToToken(updatedEndpoint.tags));

        self.userDefinedDataVisible(self.tags() || self.tmsTag() || self.price() || self.location() || self.description());
        self.updateVLOTitle();
    };

    self.deleteDevice = function(data, event) {
        let id = data.id;
        if (window.confirm(self.translationService.translate('peripheralDeleteConfirmationMessage'))) {
          WebResourceSecure.getJSON(self.baseV1Url + '/endpoints/' + self.endpointId + '/peripherals/' + id, undefined, 'DELETE')
              .then(function (data) {
                  self.peripherals().peripherals.filter((device) => device.id !== id);
              });
        }
    };

    self.editEndpoint = function () {
        var epmodal = getDataForModal();

        self.updateEndpointSignals = epmodal.parentSignals;

        if (_.isEmpty(self.onUpdateEndpointListener)) {
            self.onUpdateEndpointListener = self.updatedEndpoint.bind(self);
            self.updateEndpointSignals.onUpdateEndpoint.add(self.onUpdateEndpointListener);
        }

        self.updateEndpointSignals.showSingleUpdateModal.dispatch({
            id: self.endpointId,
            altName: _.unescape(self.altName()),
            description: _.unescape(self.description()),
            location: _.unescape(self.location()),
            price: _.unescape(self.price()),
            tags: EndpointsCommon.tagsTokenToRaw(self.tags()),
            tmsTag: EndpointsCommon.tagsTokenToRaw(self.tmsTag()),
            saveCallback: self.updatedEndpoint.bind(this)
        });
    };

    self.refreshDeviceStatus = function() {
        var self = this;

        // FYI: The URL returned includes the baseURL + "/orgs/{orgid}"
        DataProvider.getInstance().fetchAssuranceQueryServiceBaseURL()
            .then(function (base1Url) {
                self.baseV1Url = base1Url;
                DataProvider.getInstance().fetchAssuranceQueryServiceV2BaseURL()
                    .then(function (baseUrl) {
                        self.baseV2Url = baseUrl;
        
                        if (!_.isNil(self.baseV2Url)) {
                            // https://api.qa.vyopta.com/cpmm/api/v2/orgs/1/endpoints/{endpointId}
                            return WebResourceSecure.getJSON(self.baseV2Url + '/endpoints/' + self.endpointId)
                                .then(function (ep) {
                                    if (ep) {
                                        self.sourceStatus(ep.status);
                                        self.status(self.gridFormatterCommon.getStatusMarkupForEndpoint(self.gridFormatterCommon.convertStatusToNumber(ep.status)));
                                        self.peripherals(new EndpointDevices(ep)); // todo
                                        self.deviceStatusVisible(ep.device_infos.length > 0);
                                        self.muted(ep.muted);
                                        self.deviceInfos(ep.device_infos);
    
                                        if (_.isNil(self.deviceInfos()) || _.isEmpty(self.deviceInfos)) {
                                            self.deviceInfos([]);
                                        }
                                        
                                        if (_.isNil(self.sourceStatus()) || _.isEmpty(self.sourceStatus())) {
                                            self.sourceStatus('N/A');
                                        }
                                        if (_.isNil(self.microphone()) || _.isEmpty(self.microphone())) {
                                            self.microphone('N/A');
                                        }
                                        if (_.isNil(self.camera()) || _.isEmpty(self.camera())) {
                                            self.camera('N/A');
                                        }
                                        if (_.isNil(self.touchPanel()) || _.isEmpty(self.touchPanel())) {
                                            self.touchPanel('N/A');
                                        }
                                        if (_.isNil(self.displayStatus()) || _.isEmpty(self.displayStatus())) {
                                            self.displayStatus('N/A');
                                        }
                                    }
                                    return true;
                                }).catch(function(e) {
                                    console.log(e);
                                    self.sourceStatus('N/A');
                                    self.status(self.gridFormatterCommon.getStatusMarkupForEndpoint(-1));
                                    self.peripherals([]);
                                    self.deviceStatusVisible(false);
                                    self.microphone('N/A');
                                    self.camera('N/A');
                                    self.touchPanel('N/A');
                                    self.displayStatus('N/A');
                                    self.muted(false);
                                    self.deviceInfos([]);
                                });
                        }
                    });
            });
    };



    self.RefreshData();
    self.subscriptions = [];
    self.subscriptions.push(self.observableData.subscribe(function () { self.DataUpdated(); }));
}

function getDataForModal() {
    return ko.dataFor($("#updateendpoint-modal")[0].firstChild);
}

EndpointCodecInfo.prototype.RefreshData = function() {
    var self = this;

    //skip one update after edit
    if (self.justUpdated) {
        self.justUpdated = false;
        return;
    }

    var data = self.observableData();

    if (!_.isEmpty(data)) {
        // self.status(data.status);

        self.tags(EndpointsCommon.tagsRawToToken(data.tags));
        self.tmsTag(EndpointsCommon.tagsRawToToken(data.tmsTag));

        self.model(data.model);
        self.serial(data.serial);
        self.manufacturer(data.manufacturer);
        self.category(data.category);
        self.firmware(data.firmware);
        self.networkIp(data.networkIp);
        self.location(_.escape(data.location));
        self.vlan(data.vlan);

        self.cucm(data.cucm);
        self.duplex(data.duplex);
        self.primaryMgmtAddress(data.primaryMgmtAddress);

        self.name(_.escape(data.name));
        self.altName(_.escape(data.altName));
        self.description(_.escape(data.description));
        self.location(_.escape(data.location));
        self.price(_.escape(data.price));

        var imageUrl = ImageService.getImageUrl(data.model, self.manufacturer()) + '?bust=' + GLOBAL_VERSION;
        self.image(imageUrl);
        self.imageWidth("80%");
        self.imageHeight("auto");

        self.hardwareDetailsVisible(self.model() || self.category() || self.manufacturer() || self.serial());
        self.softwareDetailsVisible(self.firmware() || self.cucm() );
        self.networkDetailsVisible(self.networkIp() || self.vlan() || self.duplex() || self.primaryMgmtAddress());
        self.userDefinedDataVisible(self.tags() || self.price() || self.location() || self.description());

        self.updateVLOTitle();

        if (self.widgetSignals) {
            self.widgetSignals.dataLoaded.dispatch();
        }

        // Make a 2nd REST call to get device info not returned by the first REST call
        self.refreshDeviceStatus();
    }
};

EndpointCodecInfo.prototype.DataUpdated = function() {
    var self = this;
    self.RefreshData();
};

EndpointCodecInfo.prototype.OptionsUpdated = function() {
    var self = this;
    self.RefreshData();
};

// This runs when the component is torn down. Put here any logic necessary to clean up,
// for example cancelling setTimeouts or disposing Knockout subscriptions/computeds.
EndpointCodecInfo.prototype.dispose = function() {
    var self = this;
    self.subscriptions.forEach(function(sub) {
        sub.dispose();
    });
};

export default { viewModel: EndpointCodecInfo, template: templateMarkup, synchronous: true };
